import {
	SET_SELECTED_TRIM_DATA,
	SET_SELECTED_TRIM_COLOR_DATA,
	SET_SELECTED_TRIM_PACKAGE_DATA
} from './types';

export function setSelectedTrimData(selectedTrimData) {
	return {
		type: SET_SELECTED_TRIM_DATA,
		payload: selectedTrimData
	};
}

export function setSelectedTrimColorData(selectedTrimColorData) {
	return {
		type: SET_SELECTED_TRIM_COLOR_DATA,
		payload: selectedTrimColorData
	};
}

export function setSelectedTrimPackageData(selectedTrimPackageData) {
	return {
		type: SET_SELECTED_TRIM_PACKAGE_DATA,
		payload: selectedTrimPackageData
	};
}
